import React from 'react';
import ReactModal from 'react-modal';

export const InternalReactModal: React.FC<ReactModal.Props> = props => (
  <ReactModal {...props} style={{ overlay: { zIndex: 1200 } }} />
);
